"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelOrder = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _PopupOption = require("../PopupOption");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var CancelOrder = function CancelOrder(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    popupActive = _useState2[0],
    setPopupActive = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    optionValue = _useState4[0],
    setOptionValue = _useState4[1];
  var _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    popup = props.popup,
    modal = props.modal;
  var getOptionLabel = function getOptionLabel() {
    var target = options.find(function (i) {
      return i.value === optionValue;
    });
    return target === null || target === void 0 ? void 0 : target.label;
  };
  var modalProps = {
    title: modal === null || modal === void 0 ? void 0 : modal.title,
    children: modal === null || modal === void 0 ? void 0 : modal.content,
    footer: {
      layout: 'horizontal',
      buttons: [{
        text: modal === null || modal === void 0 ? void 0 : modal.cancelText,
        style: {
          color: '#000'
        }
      }, {
        text: modal === null || modal === void 0 ? void 0 : modal.confirmText,
        action: _objectSpread({
          _actualText_: getOptionLabel(),
          func: 'next',
          assignValues: {
            cancel_reason_code: optionValue
          }
        }, (modal === null || modal === void 0 ? void 0 : modal.confirmAction) || {})
      }]
    }
  };
  (0, _react.useEffect)(function () {
    setPopupActive(true);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_PopupOption.PopupOption, {
    showConfirm: true,
    popupProps: {
      active: popupActive,
      title: popup === null || popup === void 0 ? void 0 : popup.title,
      onClose: function onClose() {
        return setPopupActive(false);
      }
    },
    radioGroupProps: {
      value: optionValue,
      options: options,
      layout: 'vertical',
      onChange: function onChange(v) {
        return setOptionValue(v);
      }
    },
    footerProps: {
      disabled: !optionValue,
      text: popup.footerText,
      onClick: function onClick() {
        setPopupActive(false);
      }
    },
    modalProps: modalProps
  });
};
exports.CancelOrder = CancelOrder;